import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import NotificationBell from "../ui/NotificationBell";
import "../../styles/layout/game-layout.css";

const GameLayout = ({
  children,
  token,
  onLogout,
  profile = {},
  showFloatingNav = true,
  className = "",
  pageTitle = "Sportifide",
}) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Always use the real auth logout — props that pass () => {} are ignored
  const handleLogout = () => {
    if (typeof onLogout === "function") {
      onLogout();
    }
    logout();
  };

  if (!showFloatingNav) {
    return (
      <div className={`game-layout ${className}`}>
        <div className="game-background">{children}</div>
      </div>
    );
  }

  return (
    <div className={`game-layout ${className}`}>
      {/* Floating Navigation Header */}
      <div className="floating-nav">
        <div className="floating-nav-container">
          {/* Floating Logo/Title */}
          <div className="floating-logo">
            <h1
              className="floating-title"
              onClick={() => navigate("/dashboard")}
            >
              {pageTitle}
            </h1>
          </div>

          {/* Floating Navigation Buttons */}
          <div className="floating-nav-buttons">
            <button
              onClick={() => navigate("/dashboard")}
              className="floating-nav-btn home-floating"
            >
              <span className="nav-icon">🏠</span>
              Dashboard
            </button>

            <button
              onClick={() => navigate("/profile")}
              className="floating-nav-btn profile-floating"
            >
              <span className="nav-icon">👤</span>
              Profile
            </button>

            {/* Admin Access */}
            {(profile.role === "super_admin" ||
              profile.roleName === "super_admin" ||
              (Array.isArray(profile.permissions) &&
                profile.permissions.some((p) =>
                  [
                    "sports.write",
                    "sports.admin",
                    "sports_management",
                  ].includes(typeof p === "string" ? p : p.name)
                ))) && (
              <button
                onClick={() => navigate("/sports-admin")}
                className="floating-nav-btn admin-floating"
                title="Sports Administration"
              >
                <span className="nav-icon">⚙️</span>
                Admin
              </button>
            )}

            {/* Organization Sports Access */}
            {(profile.organizationId ||
              (Array.isArray(profile.permissions) &&
                profile.permissions.some((p) =>
                  ["organization.sports"].includes(
                    typeof p === "string" ? p : p.name
                  )
                ))) && (
              <button
                onClick={() => navigate("/organization-sports")}
                className="floating-nav-btn org-floating"
                title="Organization Sports Management"
              >
                <span className="nav-icon">🏟️</span>
                Org Sports
              </button>
            )}

            <NotificationBell token={token} />

            <button
              onClick={handleLogout}
              className="floating-nav-btn logout-floating"
            >
              <span className="nav-icon">🚪</span>
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Game Background with Content */}
      <div className="game-background">
        <div className="game-content">{children}</div>
      </div>
    </div>
  );
};

export default GameLayout;
